var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CDropdown',{attrs:{"toggler-text":_vm.orderOption,"placement":"right-start","addTogglerClasses":"customDropDownColor"}},[_c('CDropdownItem',{on:{"click":function($event){_vm.orderOption = 'Highest'}}},[_vm._v("Highest")]),_c('CDropdownItem',{on:{"click":function($event){_vm.orderOption = 'Lowest'}}},[_vm._v("Lowest")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }